import './ConfirmChangeBotStatus.scss';
import React from 'react';
import { Dispatch } from 'redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import useRouter from 'use-react-router';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { ModalInstanceProps } from '../interfaces';
import chatbotCRUDActions from '@mm/state/actions/ChatbotCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';

type OuterProps = {
  page: ConnectedPageModel;
  botId: number;
};

type InnerProps = ModalInstanceProps & ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const ConfirmChangeBotStatusModal = (props: Props) => {
  const { botId, page, attachToFacebookPage, closeModal } = props;

  const router = useRouter();

  const onConfirmConnect = async () => {
    await attachToFacebookPage(botId, page.id);
    closeModal();
    router.history.push(
      BotBuilderRoutes.settingsChatbot.getLink({ chatbotId: botId }),
    );
  };

  return (
    <div className="confirm-change-bot-status-modal">
      <ModalHeader>Connect Bot to {page.name}</ModalHeader>

      <ModalBody>
        Facebook page {page.name} is already connected to another bot
      </ModalBody>

      <ModalFooter>
        <Button onClick={closeModal} invert red>
          Cancel
        </Button>

        <Button autoFocus="true" onClick={onConfirmConnect}>
          Connect
        </Button>
      </ModalFooter>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  attachToFacebookPage: (
    ...args: Parameters<typeof chatbotCRUDActions.attachToFacebookPage>
  ) => dispatch(chatbotCRUDActions.attachToFacebookPage(...args)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(ConfirmChangeBotStatusModal);
